import {GET, POST} from "@/services/gateway";

const getStats = (data) => {
  const currentDate = new Date();
  data = {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  }
  return POST('dashboard/stats/salesforce', data)
}

const getApiUsage = () => {
  return GET('dashboard/salesforce/api-usage')
}

const generateSalesforceReauthUrl = () => {
  return GET('tenant/salesforce/reconnect')
}

export {
  getStats,
  getApiUsage,
  generateSalesforceReauthUrl
}
